module.exports = __webpack_public_path__ + "img/simpferopol@2x.755f990d.png";